// extracted by mini-css-extract-plugin
export default {"imageWrapper":"UP-z","hovered":"VP-z","hoverImage":"WP-z","mainImage":"XP-z","imageNoBackground":"YP-z","fullSizeImage":"ZP-z"};